import React from 'react';
import PhonicsAtoZ from './PhonicsAtoZ';
import letterDataLl from './phonics/phonics_data_ll';

function PhonicsLl() {
  return <PhonicsAtoZ letterData={letterDataLl} />;
}

export default PhonicsLl;